import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dimension-address-form"
export default class extends Controller {
  static values = {
    initialCountry: Number,
  };

  static targets = ["countryInput", "localityInput", "postalCodeInput", "autocompleteInput"];

  eraseForm() {
    this.countryInputTarget.value = this.initialCountryValue;
    this.countryInputTarget.dispatchEvent(new Event("change", { bubbles: true }));

    this.autocompleteInputTarget.value = "";
    this.localityInputTarget.value = "";
    this.postalCodeInputTarget.value = "";
  }
}
